const styles = {
  itemType: {
    width: 150,
    paddingRight: 15,
    fontSize: 16,
    textTransform: 'capitalize',
  },
  headerTitle: {
    fontSize: 16,
    fontWeight: '500',
  },
  itemWrapper: {
    width: '100%',
    padding: '5px 0px',
    display: 'flex',
  },
  itemKey: {
    width: 150,
    paddingRight: 15,
    flexShrink: 0,
  },
  image: {
    maxWidth: '100%',
    maxHeight: 300,
  },
  btnWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginLeft: 10,
  },
  inputWrapper: {
    width: 360,
    marginRight: 20,
  },
  input: {
    width: 360,
  },
};

export default styles;
